// @flow

// COMMON: Podpurna komponenta pro radio select group, ktera zpropaguje change eventu pro ucely PU (odeberte, pokud nepouzivate ve vypisu katalogu komponentu pro razeni ani komponenta pro prepnuti zobrazeni)
import RadioSelect               from 'fg-frontend/src/components/RadioSelect';
// COMMON: Intervalovy slider v1 bez podpory histogramu (odeberte, pokud nepouzivate ve vypisech produktu komponenty pro filtraci pomoci intervalu, napr. ceny, nebo pokud je pouzita komponeta RangeSlider)
import Slider                    from 'fg-frontend/components/Slider';
//COMMON Komponenta pro nastaveni ciselneho mnozstvi (odeberte, pokud v projektu neni nakupni proces)
import NumberInput               from 'fg-frontend/components/NumberInput';

// COMMON: Komponenta tlacitka Nacist dalsi v ramci strankovani
import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';
// COMMON: Komponenta pro skryti/zobrazeni casti seznamu (odeberte pokud nepouzivate Nejprodavanejsi produkty ve vypisu produktu, ani vypis parametru v detailu produktu, ani nemate v projektu nakupni proces)
import ListToggle                from 'fg-frontend/components/ListToggle';
// COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
import Typeahead                 from 'fg-frontend/components/Typeahead';
// COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
import PasswordToggle            from 'fg-frontend/components/PasswordToggle';
// COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
import SocialShare               from 'fg-frontend/components/SocialShare';
// COMMON: Komponenta intervaloveho datepickeru (odeberte, pokud nepouzivate Objednavky v B2B rezimu, nebo Faktury)
import RangeDatepicker           from 'fg-frontend/components/RangeDatepicker';
// COMMON: Zalozkovy seznam s kotvami (odeberte, pokud nepouzivate v detailu produktu)
import AnchorsList               from 'fg-frontend/src/components/AnchorsList';
// COMMON: Komponenta pro zobrazeni skupiny radio buttonu formou zalozek (odeberte, pokud nepouzivate vychozi komponentu pro razeni produktu)
import RadioSelectTab            from 'fg-frontend/src/components/RadioSelectTab';
// COMMON: Komponenta, ktera zajistuje, ze se vertikalni menu zobrazi vzdy pouze v jednom radku (odeberte, pokud na hlavni navigaci nepouzivate)
// import GreedyMenu                from 'fg-frontend/components/GreedyMenu';
// COMMON: Komponenta, ktera zkopiruje danou URL, resp. string do schranky (odeberte, pokud nepouzivate funkci Ziskat odkaz v detailu produktu ani Sdileni kosiku)
import ShareUrl                  from 'fg-frontend/src/components/ShareUrl';
// COMMON: Komponenta, ktera vytiskne libovolnou stranku z webu dle jeji URL (odeberte, pokud nepouzivate B2B objednavky, ani sdileni kosiku)
import PrintPage                 from 'fg-frontend/src/components/PrintPage';
// COMMON: Komponenta, ktera zajistuje tisk PDF (odeberte, pokud nepouzivate Faktury)
import PrintPdf                  from 'fg-frontend/src/components/PrintPdf';
// COMMON: Komponenta, ktera zajistuje presmerovani po casovem intervalu (odeberte, pokud nepouzivate zadnou platebni branu)
import RedirectToUrl             from 'fg-frontend/src/components/RedirectToUrl';
// COMMON: Komponenta pro osetreni HTML formu (odeberte, pokud nepouzivate vyber variant ve vypisu produktu ani objednavkovy pruvodce)
import Form                      from 'fg-frontend/src/components/Form';
// COMMON: Komponenta webslideru (odeberte, pokud tuto promitacku nepouzivate)
import Webslider                 from 'fg-frontend/src/components/Webslider';
// COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
import PreventDoubleClickHandler from 'fg-frontend/src/components/PreventDoubleClickHandler';
import FileInput                 from 'fg-frontend/src/components/FileInput';
// COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
import GoogleRecaptcha           from 'fg-frontend/src/components/GoogleRecaptcha';


// COMMON: Komponenta pro rozbalovani/sbalovani obsahu (odeberte, pokud ji nepouzivate ve filtrech, ani v detailu produktu, ani nepouzivate funkci sdileni kosiku a company feature)
import SimpleCollapse        from './components/SimpleCollapse';
import AddSvgIconSprite      from './components/AddSvgIconSprite';
import WebLayout             from './components/WebLayout';
import InformationRectangle  from './components/InformationRectangle';
import SelectDesign          from './components/SelectDesign';
import SeriesDetailWebslider from './components/SeriesDetailWebslider';
import Tooltip               from './components/Tooltip';
import GtmHandler            from './components/GtmHandler';
import TriggerInViewport     from './components/TriggerInViewport';
import LazyImage             from './components/LazyImage';
import PhotoSwipe            from './components/PhotoSwipe';
import Countdown             from './components/Countdown';
import Toggler               from './components/Toggler';
import Execute               from './components/Execute';
import FGUpload              from './components/FGUpload';
import CategoryCookie        from './components/CategoryCookie';
import ContentSlider         from './components/ContentSlider';
import HpPromo               from './components/HpPromo';
import InspirationWidget     from './components/InspirationWidget';
import FavouriteCategories   from './components/FavouriteCategories';
import GoogleMap             from './components/GoogleMap';
import GoogleMapDetail       from './components/GoogleMapDetail';
import TileSlider            from './components/TileSlider';
import CustomScroll          from './components/CustomScroll';
//import InstagramFeed from './components/InstagramFeed';
import { Datepicker }        from 'fg-frontend/src/components/Datepicker';
import 'flatpickr/dist/l10n/cs';

import configureEshopComponents from './configureEshopComponents';

export default (props) => {
  switch ( props.decorator || props.is ) {
    case 'AddSvgIconSprite':
      return AddSvgIconSprite;
    case 'WebLayout':
      return WebLayout;
    case 'RadioSelect':
    case 'CheckboxSelect':
      return RadioSelect;
    case 'InformationRectangle':
      return InformationRectangle;
    case 'SimpleCollapse':
      return SimpleCollapse;
    case 'SeriesDetailWebslider':
      return SeriesDetailWebslider;
    // case 'GreedyMenu':
    //   return GreedyMenu;
    case 'ContentSlider':
      return ContentSlider;
    case 'Typeahead':
      return Typeahead;
    case 'SelectDesign':
      return SelectDesign;
    case 'ListToggle':
      return ListToggle;
    case 'PasswordToggle':
      return PasswordToggle;
    case 'SocialShare':
      return SocialShare;
    case 'AnchorsList':
      return AnchorsList;
    case 'Slider':
      return Slider;
    case 'RadioSelectTab':
      return RadioSelectTab;
    case 'NumberInput':
      return NumberInput;
    case 'UniversalPaginationButton':
      return UniversalPaginationButton;
    case 'Tooltip':
      return Tooltip;
    case 'GtmHandler':
      return GtmHandler;
    case 'TriggerInViewport':
      return TriggerInViewport;
    case 'ShareUrl':
      return ShareUrl;
    case 'PhotoSwipe':
      return PhotoSwipe;
    case 'RedirectToUrl':
      return RedirectToUrl;
    case 'Form':
      return Form;
    case 'LazyImage':
      return LazyImage;
    case 'Webslider':
      return Webslider;
    case 'PreventDoubleClickHandler':
      return PreventDoubleClickHandler;
    case 'Countdown':
      return Countdown;
    case 'Toggler':
      return Toggler;
    case 'PrintPage':
      return PrintPage;
    case 'PrintPdf':
      return PrintPdf;
    case 'FileInput':
      return FileInput;
    case 'Execute':
      return Execute;
    case 'FGUpload':
      return FGUpload;
    case 'RangeDatepicker':
      return RangeDatepicker;
    case 'CategoryCookie':
      return CategoryCookie;
    case 'HpPromo':
      return HpPromo;
    case 'InspirationWidget':
      return InspirationWidget;
    case 'FavouriteCategories':
      return FavouriteCategories;
    case 'GoogleMap':
      return GoogleMap;
    case 'GoogleMapDetail':
      return GoogleMapDetail;
    case 'Datepicker':
      return Datepicker;
    case 'CustomScroll':
      return CustomScroll;
    case 'TileSlider':
      return TileSlider;
    /*case 'InstagramFeed':
      return InstagramFeed;*/
    case 'GoogleRecaptcha':
      return GoogleRecaptcha;
    default:
      const eshopComponent = configureEshopComponents(props);
      if ( eshopComponent ) {
        return eshopComponent;
      } else {
        console.log(`Unknown component ${ props.decorator || props.is }`);
        return null;
      }
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js